import React, { useMemo } from 'react'

import NumberFormat, { NumberFormatProps } from 'react-number-format'

import { roundCloser, roundDown, roundUp } from './Rounding'
import { NumberField } from '@/components/FormikInputs'
import { roundingSystem } from '@/types/unlock'

const DEFAULT_ERROR_MESSAGE = 'Calculation error'

interface ICustomNumberFormat extends NumberFormatProps {
  label?: string
  roundingSystem?: roundingSystem
  field?: boolean
  valueFlag?: React.ReactNode
  showError?: boolean
}

const CustomNumberFormat = ({
  value,
  valueFlag,
  roundingSystem,
  decimalScale = 0,
  field = false,
  ...props
}: ICustomNumberFormat) => {
  const roundedValue = useMemo(() => {
    let unformattedValue
    const roundFactor = Math.pow(10, decimalScale)

    if (typeof value === 'string') {
      unformattedValue = parseFloat(value)
    } else {
      unformattedValue = value
    }
    switch (roundingSystem) {
      case 'down':
        return roundDown(unformattedValue, roundFactor)
      case 'up':
        return roundUp(unformattedValue, roundFactor)
      case 'closer':
        return roundCloser(unformattedValue, roundFactor, decimalScale)
      default:
        return value
    }
  }, [value])

  if (value == DEFAULT_ERROR_MESSAGE) return <>{value}</>

  if (field) {
    return (
      <div className='flex'>
        <NumberField
          value={roundedValue}
          decimalScale={decimalScale}
          fixedDecimalScale={decimalScale > 0}
          {...props}
        />
        {valueFlag}
      </div>
    )
  }

  return (
    <div className='flex'>
      <NumberFormat
        value={roundedValue}
        decimalScale={decimalScale}
        fixedDecimalScale={decimalScale > 0}
        {...props}
      />
      {valueFlag}
    </div>
  )
}

export default CustomNumberFormat
